import LazyModuleWithPerfData from 'mini-performance/lib/utils/LazyModuleWithPerfData';
import safePerformanceMark from 'mini-performance/lib/utils/safePerformanceMark';
import { LazyImport } from 'owa-bundling';
import { lazyImportWithErrorHandler } from 'mini-error-handler/lib/utils/lazyImportWithErrorHandler';

const lazyModule = new LazyModuleWithPerfData(
    'MailCompose',
    () => import(/* webpackChunkName: "MailCompose" */ './lazyIndex'),
    null /** runWhen  */,
    () => safePerformanceMark('LoadComposeStart')
);

export const lazyNewMessage = new LazyImport(lazyModule, m => m.newMessage);

export const lazyNewMessageErrorHandled = lazyImportWithErrorHandler(lazyNewMessage);

export const lazyMailToMessage = new LazyImport(lazyModule, m => m.mailToMessage);

export const lazyMailToMessageErrorHandled = lazyImportWithErrorHandler(lazyMailToMessage);

export const lazyLoadDraftToCompose = lazyImportWithErrorHandler(
    new LazyImport(lazyModule, m => m.loadDraftToCompose)
);
export const lazyForwardMessage = lazyImportWithErrorHandler(
    new LazyImport(lazyModule, m => m.forwardMessage)
);
export const lazyReplyToMessage = lazyImportWithErrorHandler(
    new LazyImport(lazyModule, m => m.replyToMessage)
);
export const lazyForwardAttachment = new LazyImport(lazyModule, m => m.forwardAttachment);
export const lazyDeleteComposeDraft = new LazyImport(lazyModule, m => m.deleteComposeDraft);
export const lazyDiscardCompose = new LazyImport(lazyModule, m => m.discardCompose);
